import api from "./interceptor";

const getAllAttendance = (params) => api.get(`/attendance`, { params });
const getUserAttendance = (userId) => api.get(`/attendance/user/${userId}`);
const checkIn = (data) => api.post(`/attendance/check-in`, data);
const checkOut = (data) => api.post(`/attendance/check-out`, data);
const updateAttendanceStatus = (id, data) => api.patch(`/attendance/${id}/status`, data);
const markAbsent = (data) => api.post(`/attendance/mark-absent`, data);
const startLunch = (data) => api.post(`/attendance/start-lunch`, data);
const endLunch = (data) => api.post(`/attendance/end-lunch`, data);
const startBreak = (data) => api.post(`/attendance/start-break`, data);
const endBreak = (data) => api.post(`/attendance/end-break`, data);

export { getAllAttendance, getUserAttendance, checkIn, checkOut, updateAttendanceStatus, markAbsent, startLunch, endLunch, startBreak, endBreak };
